<template>
  <div>
    <v-row v-if="trip">
      <v-col cols="12" sm="2" md="2" lg="2">
        <v-img
          v-if="trip.driver"
          :src="trip.driver.pic"
          height="60"
          width="80"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-row v-if="!trip.driver || !trip.driver.marketDriver">
          <z-driver-select
            v-model="trip.driver"
            :label="$i18n.t('Driver')"
            @input="onDriverChange"
            :disabled="!trip.showVehicleAssign"
          />
        </v-row>

        <v-row
          v-if="trip.driver && trip.driver.marketDriver"
          style="
            align-self: center;
            height: 37px;
            border: 1px solid #d9d9d9;
            border-radius: 7px;
            align-content: space-evenly;
            margin-bottom: 10px;
            background: #f6f6f6;
          "
        >
          <v-col cols="12" sm="4" md="4" lg="4" v-if="trip.driver">{{
            trip.driver.name
          }}</v-col>
          <v-col cols="12" sm="6" md="6" lg="6" v-if="trip.driver"
            >{{ trip.driver.countryCode }} {{ trip.driver.phone }}</v-col
          >
        </v-row>

        <v-row>
          <v-chip
            small
            color="green"
            dark
            v-if="
              trip.driver != null &&
              trip.driver.driverOf &&
              !trip.driver.marketDriver &&
              trip.vendor_id != trip.driver.driverOf
            "
            >{{ $i18n.t("Supplier Driver") }} -
            {{ trip.driver.driverOwner }}</v-chip
          >
          <v-chip
            small
            color="cyan"
            dark
            v-if="
              trip.driver != null && trip.vendor_id == trip.driver.driverOf
            "
            >{{ $i18n.t("Own Driver") }}</v-chip
          ><v-chip
            small
            color="cyan"
            dark
            v-if="trip.driver != null && trip.driver.marketDriver"
            >{{ $i18n.t("Market Driver") }}</v-chip
          >
        </v-row>
      </v-col>
      <v-col
        cols="12"
        :class="!trip.driver.marketDriver ? 'px-10 py-5' : 'px-10'"
        sm="4"
        md="4"
        lg="4"
      >
        <v-row>
          <v-btn
            x-small
            fab
            color="blue lighten-1"
            v-if="trip.showVehicleAssign && trip.driver.marketDriver"
            @click="driverCreateDialog = true"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <v-tooltip
            top
            v-if="trip.showVehicleAssign && trip.driver && trip.driver.name"
          >
            <template v-slot:activator="{ tooltip }">
              <z-confirm-button
                @click="unassignDriver(trip)"
                fab
                x-small
                color="error lighten-1"
                v-on="tooltip"
                :message="$i18n.t('Are you sure you want to unassign Driver?')"
              >
                <v-icon>mdi-close</v-icon>
              </z-confirm-button>
            </template>
            <span>{{ $i18n.t("Unassign Driver") }}</span>
          </v-tooltip>
          <v-btn
            x-small
            fab
            color="blue lighten-1"
            v-if="trip.showVehicleAssign"
            @click="showAddNewDriver"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>

    <z-vehicle-create-adhoc
      :trip_id="trip._id"
      :forDriver="true"
      :owner_id="driverSupplier_id"
      :driverCreateDialog="driverCreateDialog"
      @closeDriverCreateDialog="closeDriverCreateDialog"
      @setAdhocDriver="setDriverData"
    >
    </z-vehicle-create-adhoc>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "Driver",
  props: {
    trip: {
      default: null,
    },
    bodyType: {
      default: null,
    },
    truckType: {
      default: null,
    },
    owner_id: {
      default: null,
    },
  },
})
export default class Driver extends (Vue, Themeable) {
  dialog = false;
  driverSupplier_id = null;
  driverCreateDialog = null;

  onDriverChange(newVal) {
    this.$emit("input", newVal);
  }

  unassignDriver() {
    this.$emit("unassignDriver");
  }

  closeDriverCreateDialog() {
    this.driverCreateDialog = null;
  }

  setDriverData(driver) {
    this.$emit("setAdhocDriver", driver);
  }

  showAddNewDriver() {
    if (this.trip && this.trip.billings) {
      for (let _i = 0; _i < this.trip.billings.length; _i++) {
        if (this.trip.billings[_i].client_id != this.trip.corp_id) {
          this.driverSupplier_id = this.trip.billings[_i].vendor_id;
        }
      }
    }
    if (
      !this.driverSupplier_id &&
      this.trip &&
      this.trip.driver &&
      this.trip.driver.driverOf &&
      this.trip.driver.driverOf != this.trip.myCorp_id
    ) {
      this.driverSupplier_id = this.trip.driver.driverOf;
    }
    this.driverCreateDialog = null;
    this.driverCreateDialog = true;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
</style>
